module.exports = __webpack_public_path__ + "img/PRODUCTION.04fce4f1.svg";